var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticClass:"d-block",attrs:{"value":_vm.selected,"placeholder":_vm.placeholder || _vm.$t('message.status'),"filterable":"","clearable":"","size":_vm.size},on:{"input":_vm.dispatch}},_vm._l((_vm.statuses),function(status,index){return _c('el-option',{key:'status-' + index,attrs:{"label":status.name,"value":status.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }